import Delegate from "ftdomdelegate";
import { qs } from "@fluorescent/dom";

import { cart } from "@/glow";
import { emit } from "evx";

const selectors = {
  item: "[data-input-item]",
  itemProperties: "[data-item-properties]",
  quantityInput: "[data-quantity-input]",
  quantityAdd: "[data-add-quantity]",
  quantitySubtract: "[data-subtract-quantity]",
  removeItem: "[data-remove-item]",
};

export default function QuantityButtons(node) {
  const delegate = new Delegate(node);

  delegate.on("click", selectors.quantitySubtract, (e, target) => {
    const item = target.closest(selectors.item);
    const { key } = item.dataset;
    const quantityInput = qs(selectors.quantityInput, item);
    const { currentQuantity, minQuantity, step } =
      _getQuantityValues(quantityInput);

    const newQuantity = currentQuantity - step;
    const newValue = Math.max(newQuantity, minQuantity);

    emit("quantity-update:subtract", null, {
      key,
    });

    cart.updateItem(key, newValue);
  });

  delegate.on("click", selectors.quantityAdd, (e, target) => {
    const item = target.closest(selectors.item);
    const { key } = item.dataset;
    const quantityInput = qs(selectors.quantityInput, item);
    const { currentQuantity, step, maxQuantity } =
      _getQuantityValues(quantityInput);

    const newQuantity = currentQuantity + step;
    let newValue;

    if (maxQuantity) {
      newValue = Math.min(newQuantity, maxQuantity);
    } else {
      newValue = newQuantity;
    }

    emit("quantity-update:add", null, {
      key,
    });

    cart.updateItem(key, newValue);
  });

  delegate.on("click", selectors.removeItem, (_, target) => {
    const item = target.closest(selectors.item);
    const { key } = item.dataset;

    emit("quantity-update:remove", null, {
      key,
    });

    cart.updateItem(key, 0);
  });

  /**
   *
   * @param {element} input - The input element to gather values and rules from.
   * @returns {{currentQuantity: int, minQuantity: int, step: int, maxQuantity: int}} - All of the values within an Object.
   */
  const _getQuantityValues = input => {
    const currentQuantity = parseInt(input.value, 10);
    const minQuantity = parseInt(input.getAttribute("min"), 10);
    const step = parseInt(input.getAttribute("step"), 10);
    const maxQuantity = parseInt(input.getAttribute("max"), 10);

    return { currentQuantity, minQuantity, step, maxQuantity };
  };

  const unload = () => {
    delegate.off();
  };

  return {
    unload,
  };
}
